// Marchio LEUTELIA — monogramma "L1": due L interbloccate a simmetria rotazionale (180°).
// Nera = barra verticale sinistra (piena) + piede orizzontale in basso.
// Bordeaux = barra verticale destra (piena) + cappello orizzontale in alto.

export function Monogram({ size = 34, a = "#141414", b = "#6E1E14" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" aria-hidden shapeRendering="crispEdges">
      {/* L nera: verticale sinistra + piede basso */}
      <rect x="4" y="4" width="30" height="92" fill={a} />
      <rect x="4" y="66" width="60" height="30" fill={a} />
      {/* L bordeaux (ruotata 180°): verticale destra + cappello alto */}
      <rect x="66" y="4" width="30" height="92" fill={b} />
      <rect x="36" y="4" width="60" height="30" fill={b} />
    </svg>
  );
}

export default function Logo({ compact = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="leutelia-logo">
      <Monogram size={compact ? 30 : 38} a="#F5F1E8" b="#C6902A" />
      <div className="leading-none">
        <div
          className="font-serif text-brand-cream"
          style={{ letterSpacing: "0.32em", fontSize: compact ? 16 : 19, fontWeight: 500 }}
        >
          LEUTELIA
          <span style={{ color: "#C6902A" }}>.</span>
        </div>
        {!compact && (
          <div
            className="text-brand-goldSoft/85 mt-1.5"
            style={{ letterSpacing: "0.24em", fontSize: 7.5, fontWeight: 700 }}
          >
            HOTEL INTELLIGENCE STUDIO
          </div>
        )}
      </div>
    </div>
  );
}
